import * as i0 from '@angular/core';
import * as i1 from './tree-grid.module';
import * as i2 from '@angular/common';
import * as i3 from '../cdk/table/table.module';
import * as i4 from '../cdk/table/cell';
import * as i5 from '../cdk/table/row';
import * as i6 from './tree-grid.component';
import * as i7 from './tree-grid-def.component';
import * as i8 from './tree-grid-row.component';
import * as i9 from './tree-grid-cell.component';
import * as i10 from './tree-grid-column-def.directive';
import * as i11 from './tree-grid-sort.component';
import * as i12 from './tree-grid-filter';
import * as i13 from './tree-grid-row-toggle.directive';
import * as i14 from './tree-grid-row-toggle.component';
export const NbTreeGridModuleNgFactory:i0.NgModuleFactory<i1.NbTreeGridModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.NbTable<any> = (<any>(null as any));
var _decl0_12:i4.NbHeaderCellDefDirective = (<any>(null as any));
var _decl0_13:i5.NbHeaderRowDefDirective = (<any>(null as any));
var _decl0_14:i4.NbColumnDefDirective = (<any>(null as any));
var _decl0_15:i4.NbCellDefDirective = (<any>(null as any));
var _decl0_16:i5.NbRowDefDirective<any> = (<any>(null as any));
var _decl0_17:i4.NbFooterCellDefDirective = (<any>(null as any));
var _decl0_18:i5.NbFooterRowDefDirective = (<any>(null as any));
var _decl0_19:i5.NbDataRowOutletDirective = (<any>(null as any));
var _decl0_20:i5.NbHeaderRowOutletDirective = (<any>(null as any));
var _decl0_21:i5.NbFooterRowOutletDirective = (<any>(null as any));
var _decl0_22:i5.NbCellOutletDirective = (<any>(null as any));
var _decl0_23:i4.NbHeaderCellDirective = (<any>(null as any));
var _decl0_24:i4.NbCellDirective = (<any>(null as any));
var _decl0_25:i4.NbFooterCellDirective = (<any>(null as any));
var _decl0_26:i5.NbHeaderRowComponent = (<any>(null as any));
var _decl0_27:i5.NbRowComponent = (<any>(null as any));
var _decl0_28:i5.NbFooterRowComponent = (<any>(null as any));
var _decl0_29:i6.NbTreeGridComponent<any> = (<any>(null as any));
var _decl0_30:i7.NbTreeGridRowDefDirective<any> = (<any>(null as any));
var _decl0_31:i8.NbTreeGridRowComponent = (<any>(null as any));
var _decl0_32:i7.NbTreeGridCellDefDirective = (<any>(null as any));
var _decl0_33:i9.NbTreeGridCellDirective = (<any>(null as any));
var _decl0_34:i7.NbTreeGridHeaderRowDefDirective = (<any>(null as any));
var _decl0_35:i8.NbTreeGridHeaderRowComponent = (<any>(null as any));
var _decl0_36:i7.NbTreeGridHeaderCellDefDirective = (<any>(null as any));
var _decl0_37:i9.NbTreeGridHeaderCellDirective = (<any>(null as any));
var _decl0_38:i7.NbTreeGridFooterRowDefDirective = (<any>(null as any));
var _decl0_39:i8.NbTreeGridFooterRowComponent = (<any>(null as any));
var _decl0_40:i7.NbTreeGridFooterCellDefDirective = (<any>(null as any));
var _decl0_41:i9.NbTreeGridFooterCellDirective = (<any>(null as any));
var _decl0_42:i10.NbTreeGridColumnDefDirective = (<any>(null as any));
var _decl0_43:i11.NbSortDirective = (<any>(null as any));
var _decl0_44:i11.NbSortHeaderComponent = (<any>(null as any));
var _decl0_45:i11.NbSortIconComponent = (<any>(null as any));
var _decl0_46:i12.NbFilterDirective = (<any>(null as any));
var _decl0_47:i12.NbFilterInputDirective = (<any>(null as any));
var _decl0_48:i13.NbTreeGridRowToggleDirective = (<any>(null as any));
var _decl0_49:i14.NbTreeGridRowToggleComponent = (<any>(null as any));
var _decl0_50:i11.NbSortHeaderIconDirective = (<any>(null as any));
var _decl0_51:i2.AsyncPipe = (<any>(null as any));
var _decl0_52:i2.UpperCasePipe = (<any>(null as any));
var _decl0_53:i2.LowerCasePipe = (<any>(null as any));
var _decl0_54:i2.JsonPipe = (<any>(null as any));
var _decl0_55:i2.SlicePipe = (<any>(null as any));
var _decl0_56:i2.DecimalPipe = (<any>(null as any));
var _decl0_57:i2.PercentPipe = (<any>(null as any));
var _decl0_58:i2.TitleCasePipe = (<any>(null as any));
var _decl0_59:i2.CurrencyPipe = (<any>(null as any));
var _decl0_60:i2.DatePipe = (<any>(null as any));
var _decl0_61:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_62:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_63:i2.KeyValuePipe = (<any>(null as any));
var _decl0_64:i2.CommonModule = (<any>(null as any));
var _decl0_66:i3.NbTableModule = (<any>(null as any));
var _decl0_67:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_68:i0.ElementRef<any> = (<any>(null as any));
function _View_NbTreeGridComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = _decl0_29.treeClass;
  currVal_1;
}
function _View_NbTreeGridComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_NbTreeGridRowComponent_Host_2_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_31.toggleIfEnabledNode()) !== false);
  const pd_1:any = ((<any>_decl0_31.toggleIfEnabledNodeDeep()) !== false);
}
function _View_NbTreeGridRowComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_NbTreeGridHeaderRowComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_NbTreeGridHeaderRowComponent_3_0():void {
  var _any:any = (null as any);
}
function _View_NbTreeGridFooterRowComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_NbTreeGridFooterRowComponent_4_0():void {
  var _any:any = (null as any);
}
function _View_NbSortHeaderComponent_Host_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = _decl0_44.disabled;
  currVal_1;
  const pd_2:any = ((<any>_decl0_44.sortIfEnabled()) !== false);
}
function _View_NbSortHeaderComponent_5_1():void {
  if (!_decl0_44.sortIcon) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_44.direction;
    currVal_0;
  }
}
function _View_NbSortHeaderComponent_5_2():void {
  var _any:any = (null as any);
}
function _View_NbSortHeaderComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_44.getDisabledAttributeValue();
  currVal_0;
  const currVal_1:any = !_decl0_44.sortIcon;
  currVal_1;
  const currVal_2:any = _decl0_67;
  currVal_2;
  const currVal_3:any = _decl0_44.getIconContext();
  currVal_3;
  const currVal_4:any = _decl0_44.sortIcon;
  currVal_4;
  const pd_5:any = ((<any>_decl0_44.sortData()) !== false);
}
function _View_NbSortIconComponent_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_NbSortIconComponent_6_1():void {
  if (_decl0_45.isDirectionSet()) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_45.isAscending();
    currVal_0;
    const currVal_1:any = _decl0_45.isDescending();
    currVal_1;
  }
}
function _View_NbSortIconComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_45.isDirectionSet();
  currVal_0;
}
function _View_NbTreeGridRowToggleComponent_Host_7_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_49.toggleRow(_any)) !== false);
}
function _View_NbTreeGridRowToggleComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_49.expanded? 'collapse': 'expand');
  currVal_0;
  const currVal_1:any = !_decl0_49.expanded;
  currVal_1;
  const currVal_2:any = _decl0_49.expanded;
  currVal_2;
}
